import { render, staticRenderFns } from "./OwnersDocsCreate.vue?vue&type=template&id=22461029&scoped=true&"
import script from "./OwnersDocsCreate.vue?vue&type=script&lang=js&"
export * from "./OwnersDocsCreate.vue?vue&type=script&lang=js&"
import style0 from "./OwnersDocsCreate.vue?vue&type=style&index=0&id=22461029&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22461029",
  null
  
)

export default component.exports